import React, { useState, useEffect } from "react";
import { Route, RouteProps } from 'react-router-dom';
import { useMsal } from "@azure/msal-react";
import { AccountInfo } from "@azure/msal-browser";
import { msalConfig } from '../../authConfig'
import { configuration } from "../../configs";


interface RouteGuardProps extends RouteProps {
  roles?: string[];
}

export type IdTokenClaims = {
  aud: string;
  roles: string[];
};

const RouteGuard = (props: RouteGuardProps) => {
  const { instance } = useMsal();
  const [isAuthorized, setIsAuthorized] = useState(false);
  const [message, setMessage] = useState("");
  const onLoad = async () => {
    var isUserAdmin = false;
    const currentAccount = instance.getActiveAccount();
    if (currentAccount) {
      if (currentAccount.tenantId === configuration.AUTH_TENANT_ID) {
        const idTokenClaims = currentAccount.idTokenClaims as IdTokenClaims;
        if (idTokenClaims && idTokenClaims.aud === configuration.AUTH_CLIENT_ID && idTokenClaims["roles"]) {
          const intersection = props.roles?.filter((role: any) => idTokenClaims["roles"].includes(role)) || [];
          if (intersection.length > 0) {
            isUserAdmin = true;
            setIsAuthorized(true);
            window.dispatchEvent(new Event("UserIsAdmin"));

          } else {
            setMessage("You don't have the required role to view this page. Please contact site administrator.");
          }
        } else {
          setMessage("The application you authorized with cannot access this page. Please contact site administrator.");
        }
      } else {
        setMessage("Your organization does not have access this content.");
      }
    }
    sessionStorage.setItem("isUserAdmin", isUserAdmin.toString());
  };
  useEffect(() => {
    onLoad();
  }, [instance]); // Added dependency to prevent infinite re-renders
  return (
    <>
      <>
        {isAuthorized ? (
          <Route {...props} />
        ) : (
          <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh" }}>
            <h4>{message}</h4>
          </div>
        )}
      </>
    </>
  );
};
export default RouteGuard;